export default function initiateQr(
  state = { error: null, success: null, processing: "" },
  action
) {
  switch (action.type) {

    case 'INITIATE_QR_SUCCESS':
      return {...state, ...{success: action.success,error:null}};
    case 'INITIATE_QR_ERROR':
      return {...state, ...{error: action.error.response,success:null}};
    case 'INITIATE_QR_PROCESSING':
      return {...state, ...{processing: action.processing}};
    default:
      return state;
  }
}
